'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'

import { FooterRoutes } from '../../../App.constants'
import { EVERSPORTS_LOGO } from '../../../App.icons'

export const ForbiddenFooter = () => {
  const t = useTranslations('footer')

  return (
    <footer className="flex w-full flex-col items-center gap-3 bg-surface-primary px-4 py-6 text-xs text-text-descriptive">
      <a href="/" target="_blank" className="flex items-center gap-2 text-sm text-text-descriptive">
        <span>{t('we-use-eversports-label')}</span>
        <Image src={EVERSPORTS_LOGO} alt="Eversports" width={109} height={22} />
      </a>
      <div className="flex items-center gap-2">
        <a href={FooterRoutes.PRIVACY}>{t('privacy-policy')}</a>
        <a href={FooterRoutes.TERMS}>{t('terms-and-conditions')}</a>
      </div>
    </footer>
  )
}
